// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShowMoreButton__popover-c449a9 {
  background-color: var(--light-10-addition-120);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/ShowMoreButton/ShowMoreButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,8CAAA;AACF","sourcesContent":[".popover {\n  background-color: var(--light-10-addition-120);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `ShowMoreButton__popover-c449a9`
};
module.exports = ___CSS_LOADER_EXPORT___;
